module.exports = __webpack_public_path__ + "static/img/cpjzx_1@2x.8fae7d71.png";